import React, { useState, useEffect, useCallback } from 'react';
import SampleCard from './SampleCard';
import SampleDetail from './SampleDetail';
import './SampleCardsSection.css';

const SampleCardsSection = ({ samples: filteredSamples, onRefreshData }) => {
    const [samples, setSamples] = useState([]);
    const [selectedSample, setSelectedSample] = useState(null);
    const [showDetailModal, setShowDetailModal] = useState(false);

    // Update samples when filtered samples change
    useEffect(() => {
        if (filteredSamples && filteredSamples.length > 0) {
            console.log('SampleCardsSection: Updating samples from filteredSamples, count:', filteredSamples.length);
            setSamples(filteredSamples);
        } else {
            // If no filtered samples are provided, just use an empty array
            console.log('SampleCardsSection: No filtered samples provided, using empty array');
            setSamples([]);
        }
    }, [filteredSamples]);

    // Handle card click
    const handleCardClick = (sample) => {
        console.log('SampleCardsSection: Card clicked for sample:', sample.barcode);
        setSelectedSample(sample);
        setShowDetailModal(true);
    };

    // Close detail modal
    const handleCloseDetail = () => {
        console.log('SampleCardsSection: Closing detail modal');
        setShowDetailModal(false);
        setSelectedSample(null);
    };

    // Handle save changes from SampleDetail
    const handleSaveChanges = useCallback(() => {
        console.log('SampleCardsSection: Triggering data refresh');
        if (onRefreshData) {
            console.log('SampleCardsSection: onRefreshData function exists, calling it');
            // Call the refresh function from the parent component
            onRefreshData();
        } else {
            console.log('SampleCardsSection: onRefreshData function does not exist');
        }
    }, [onRefreshData]);

    return (
        <div className="samplemanager-cards-section">
            {samples.length > 0 ? (
                samples.map(sample => (
                    <SampleCard 
                        key={sample.barcode || sample.patientId} 
                        sample={sample} 
                        onClick={handleCardClick}
                    />
                ))
            ) : (
                <div className="samplemanager-no-results">
                    <p>No samples match your search criteria</p>
                </div>
            )}
            
            {showDetailModal && selectedSample && (
                <SampleDetail 
                    sample={selectedSample}
                    onClose={handleCloseDetail}
                    onSaveChanges={handleSaveChanges}
                />
            )}
        </div>
    );
};

export default SampleCardsSection;
